import { AudioRecordingModelData } from "@/store/audio-recordings";
import { AudioRecordingRetranscriptionStatus } from "@/store/audio-recordings/types";
import {
  BaseAudioRecordingAppEventOperation,
  BaseAudioRecordingAppEventOperationParams,
} from "./BaseAudioRecordingAppEventOperation";

/**
 * Operation to mark that an audio recording has started the retranscription process.
 * This is used when the local transcript is unavailable and we need to retranscribe
 * from the uploaded audio.
 */
export class MarkStartedRetranscribingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind() {
    return "MARK_STARTED_RETRANSCRIBING_AUDIO_RECORDING" as const;
  }

  constructor(params: BaseAudioRecordingAppEventOperationParams) {
    super(params);
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    if (existingData.retranscription_status === AudioRecordingRetranscriptionStatus.COMPLETED) {
      return {};
    }

    return {
      retranscription_status: AudioRecordingRetranscriptionStatus.IN_PROGRESS,
    };
  }
}
